/**
 * activity-logger
 *
 * Description:
 * Common function to log guest-journey activity events to the backend.
 * Fire-and-forget: never throws, never blocks the calling UI flow.
 */

import { store } from "./../store/index";
import { activityLogActions } from "./../store/activityLog.slice";

// Session id normally starts on the welcome page (see welcome.js). This is only
// a fallback for guests who deep-link straight into a later step and skip it.
// Exported so other API-calling code (e.g. fetch-wrapper.js) can tag requests
// with the same session id the backend sees on /activity-log.
export function getOrCreateSessionId() {
  const currentSessionId = store.getState().activityLog?.sessionId;
  if (currentSessionId) return currentSessionId;
  const sessionId = crypto.randomUUID();
  store.dispatch(activityLogActions.setSessionId(sessionId));
  return sessionId;
}

// display_currency / display_language enrichment skipped for now.
export const logActivity = (eventName, metadata = {}) => {
  try {
    const { checkIn } = store.getState();
    const enrichedMetadata = { ...metadata };
    if (enrichedMetadata.checkin_date === undefined) enrichedMetadata.checkin_date = checkIn?.checkinDate;
    if (enrichedMetadata.checkout_date === undefined) enrichedMetadata.checkout_date = checkIn?.checkoutDate;
    enrichedMetadata.domain_url = `${window.location.origin}/`;
    enrichedMetadata.url_params = `${window.location.pathname}${window.location.search}`.replace(/^\//, "");

    const payload = {
      event_name: eventName,
      booking_slug: checkIn?.bookingSlug,
      listing_slug: checkIn?.listingSlug,
      // slug: checkIn?.listingSlug, // same value already sent as listing_slug above — commented out to avoid duplication
      session_id: getOrCreateSessionId(),
      metadata: enrichedMetadata,
    };

    store.dispatch(activityLogActions.logActivity(payload));
  } catch (error) {
    console.error("Activity log failed:", error);
  }
};
